import PropTypes from 'prop-types';

/**
 * Timeline Graphic
 * @memberof module:react/propTypes
 * @typedef {Object} TimelineGraphic
 * @prop {number} id Id of the Graphic
 * @prop {string} mosObjectId Id of the mos Object
 * @prop {string} title title
 * @prop {string} previewImgUrl Url of the preview image
 * @prop {string} mosXml mosXml of the generated mos Object
 * @prop {number} start Start location
 * @prop {number} end End location
 * @prop {string} duration Duration timecode
 * @prop {bool} selected Selected
 * @prop {bool} focused Focused
 */
export default PropTypes.shape({
  id: PropTypes.number,
  mosObjectId: PropTypes.string,
  title: PropTypes.string,
  previewImgUrl: PropTypes.string,
  mosXml: PropTypes.string,
  start: PropTypes.number,
  end: PropTypes.number,
  duration: PropTypes.string,
  selected: PropTypes.bool,
  focused: PropTypes.bool
});



// WEBPACK FOOTER //
// ./app/propTypes/timelineGraphic.js